import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { Icon } from '@drifthq/tide-core'

import VideoSuccessStep from 'layouts/VideoSuccessStep'
import VideoInstallStep from 'layouts/VideoInstallStep'
import VideoLandingStep from 'layouts/VideoLandingStep'

import graffitiTextureDesktop from './graffiti-texture-desktop.svg'
import graffitiTextureDesktop2 from './graffiti-texture-desktop-2.svg'

import './style.css'

const VideoController = () => {
  return (
    <div className="video-setup-container">
      <img className="video-setup-background-left" src={graffitiTextureDesktop} alt="" />
      <img className="video-setup-background-right" src={graffitiTextureDesktop2} alt="" />
      <div className="video-logo-container">
        <Icon className="video-drift-logo" name="drift-logo-round" />
        <span className="video-container-header">Video</span>
      </div>
      <div className="video-setup-content">
        <Switch>
          <Route exact path="/video/success" component={VideoSuccessStep} />
          <Route exact path="/video/extension" component={VideoInstallStep} />
          <Route exact path="/video/landing" component={VideoLandingStep} />
          <Route path="/" component={VideoInstallStep} />
        </Switch>
      </div>
    </div>
  )
}

export default VideoController



// WEBPACK FOOTER //
// ./src/layouts/VideoController/index.js